import { ButtonBase, ButtonIcon } from '@/components/Button';
import SubTitle from '@/components/SubTitle.vue';
import ModalMovie from '@/components/Modal/ModalMovie.vue';
import CardExploreMovie from '@/components/Card/CardExploreMovie.vue';
import VPagination from 'vue3-pagination';

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(Vue) {
    Vue.component('button-base', ButtonBase);
    Vue.component('button-icon', ButtonIcon);
    Vue.component('subtitle', SubTitle);
    Vue.component('modal-movie', ModalMovie);
    Vue.component('card-explore-movie', CardExploreMovie);
    Vue.component('v-pagination', VPagination);
  },
};

export default GlobalComponents;
